import { useEffect } from "react";

import { useAuth } from "../../features/auth/AuthContext";
import { FEATURE_FLAG_PIPELINE_CONFIG_SYNC } from "../features";
import { useFeatureFlagEnabled } from "../posthog";
import { usePipelineConfigSyncStore } from "../stores/pipelineConfigSyncStore";
import { PipelineConfigSyncStatus } from "../types/pipelineConfigSync";

interface UsePipelineConfigSyncResult {
  syncPipelineConfig: () => void;
  isSyncing: boolean;
  syncError: string | null;
  syncEnabled: boolean;
  lastSyncAt: Date | null;
  lastSyncStatus: PipelineConfigSyncStatus | null;
  refreshSyncStatus: () => Promise<void>;
}

export const usePipelineConfigSync = (): UsePipelineConfigSyncResult => {
  const { tenantId } = useAuth();
  const syncEnabled = useFeatureFlagEnabled(FEATURE_FLAG_PIPELINE_CONFIG_SYNC);
  const {
    triggerPipelineConfigSync,
    isSyncing,
    syncError,
    setPipelineConfigSyncEnabled,
    lastSyncAt,
    lastSyncStatus,
    refreshSyncStatus
  } = usePipelineConfigSyncStore();

  useEffect(() => {
    setPipelineConfigSyncEnabled(syncEnabled);
  }, [syncEnabled, setPipelineConfigSyncEnabled]);

  const syncPipelineConfig = () => {
    if (!tenantId) {
      return;
    }
    triggerPipelineConfigSync(tenantId);
  };

  return {
    syncPipelineConfig,
    isSyncing,
    syncError,
    syncEnabled,
    lastSyncAt,
    lastSyncStatus,
    refreshSyncStatus
  };
};
